<p translate>add-learners-step.add-learner-info</p>
<vnm-tile-card
  header="add-learners-step.import-learners-title"
  [subheader]="'add-learners-step.' + learnerI18nNamespace + '.import-learners-info'"
>
  <vnm-learners-import (imported)="addLearners($event)" [importObjects]="learnerI18nNamespace"></vnm-learners-import>
</vnm-tile-card>
<div class="decorator" translate>app.or</div>
<vnm-tile-card
  [header]="'add-learners-step.' + learnerI18nNamespace + '.manual-add-title'"
  [subheader]="'add-learners-step.' + learnerI18nNamespace + '.manual-add-info'"
>
  <form [formGroup]="learnerForm" (ngSubmit)="addLearner($event)" class="learner-form">
    <vnm-form-field label="add-learners-step.learner-name">
      <input
        pInputText
        type="text"
        class="inputfield w-full p-block"
        vnmPlaceholder="app.first-name"
        formControlName="firstName"
      />
      <input
        pInputText
        type="text"
        class="inputfield w-full p-block"
        vnmPlaceholder="app.last-name"
        formControlName="lastName"
      />
    </vnm-form-field>
    <vnm-form-field
      label="add-learners-step.learner-contact"
      [info]="requireContactMethod ? 'add-learners-step.learner-contact-info' : null"
      [help]="requireContactMethod ? 'add-learners-step.learner-contact-help' : null"
    >
      <input
        pInputText
        type="email"
        class="inputfield w-full"
        vnmPlaceholder="app.email-placeholder"
        [pattern]="emailPattern"
        formControlName="email"
        [requiredIf]="requireContactMethod && !learnerForm.get('mobileNumber').value"
      />
      <p-inputMask
        styleClass="inputfield w-full"
        [placeholder]="'app.phone-placeholder' | translate"
        formControlName="mobileNumber"
        mask="(999) 999-9999"
        [requiredIf]="requireContactMethod && !learnerForm.get('email').value"
      ></p-inputMask>
    </vnm-form-field>
    <vnm-form-actions
      [submitLabel]="
        'add-learners-step.' + learnerI18nNamespace + (learners.length ? '.add-another-learner' : '.add-learner')
      "
      submitIcon="fa fa-fw fa-plus"
      submitClass="flex-1"
      [showCancel]="false"
    ></vnm-form-actions>
  </form>
</vnm-tile-card>
<hr />
<vnm-tile-card *ngIf="learners.length > 0">
  <vnm-flex-container card-header>
    <vnm-card-title [header]="'add-learners-step.' + learnerI18nNamespace + '.learners-to-add'"></vnm-card-title>
    <vnm-badge [value]="learners.length" flex-end>
      <fa-icon icon="users"></fa-icon>
    </vnm-badge>
  </vnm-flex-container>
  <div class="learner-list">
    <div *ngFor="let learner of learners" class="learner-list-item">
      <div>
        <span>{{ learner.firstName }} {{ learner.lastName }}</span>
        <small>{{ learner.email }} {{ learner.mobileNumber | phone }}</small>
      </div>
      <button
        type="button"
        pButton
        icon="fa fa-fw fa-trash"
        (click)="onRemove(learner)"
        class="p-button-rounded p-button-text p-button-danger"
      ></button>
    </div>
  </div>
</vnm-tile-card>
<p-footer>
  <vnm-max-learners-message
    [maxAdd]="maxAdd"
    [learnerCount]="learners.length"
    [tooManyLearnersMessage]="tooManyLearnersMessage"
  ></vnm-max-learners-message>
  <p-message
    *ngIf="maxAdd - learners.length === 0"
    severity="warn"
    [text]="'add-learners-step.class-full' | translate"
  ></p-message>
  <div class="wizard-actions">
    <button
      pButton
      type="button"
      icon="fa fa-fw fa-times"
      class="p-button-secondary"
      [label]="'app.cancel' | translate"
      (click)="cancel.emit()"
    ></button>
    <button
      pButton
      type="button"
      icon="fa fa-fw fa-angle-right"
      iconPos="right"
      [label]="nextStepLabel | translate: { learners: learners.length }"
      [disabled]="!learners.length"
      (click)="nextStep.emit()"
    ></button>
  </div>
</p-footer>
